import { RightArrowIcon } from "src/assets";
import { MAX_DATA_ENTRY_STEP } from "src/config";
import { typedMemo } from "src/types";
import { SignatureStep } from "src/ui/fragments";
import { Button, FormRow, InputText, Separator, ModalSignature } from "src/ui/widgets";
import { InputPhone } from "src/ui/widgets/input-phone/input-phone";
import { useSignatureB } from "./signature-b.hook";

export const SignatureB = typedMemo(() => {
  const {
    formikCAI,
    formikSignatureB,
    signatureValidationSchema,
    signatureChoiceVisibility,
    isLoadingCommunicationToken,
    showRetryModal,
    signInProgressMessage,
    t,
    sendDossier,
    createDossier,
    checkSignStatus,
  } = useSignatureB();

  const { vehicleB } = formikCAI;

  const {
    handleChange,
    handleBlur,
    setFieldTouched,
    setFieldValue,
    handleSubmit,
  } = formikSignatureB;

  const TopBody = (
    <div>
      <div className="title-l--600">{t("data_entry.title")}</div>
      <div className="subtitle-xs mt-1 mb-2 c-light">
        {t("data_entry.subtitle")}
      </div>
      <div className="subtitle-s">
        {t("data_entry.step_title", {
          act_step: 5,
          max_step: MAX_DATA_ENTRY_STEP,
        })}
      </div>
      <Separator classes="my-3" />
    </div>
  );

  const Title = (
    <div className="mb-2">
      <div className="title-xs--700 mb-2">
        {t("data_entry.signature_b_step.title")}
      </div>
      <div className="subtitle-xs">
        {t("data_entry.signature_b_step.subtitle_1")}
      </div>
      <div className="subtitle-xs">
        {t("data_entry.signature_b_step.subtitle_2")}
      </div>
      <div className="subtitle-xs">
        {t("data_entry.signature_b_step.subtitle_3")}
      </div>
    </div>
  );

  const Body = (
    <div className="mt-4">
      <FormRow
        firstField={
          <InputText
            name={`email`}
            handleChange={handleChange}
            handleBlur={handleBlur}
            validationSchema={signatureValidationSchema}
            touched={formikSignatureB.touched.email}
            value={formikSignatureB.values.email}
            error={formikSignatureB.errors.email}
            label={t("data_entry.signature_b_step.email_field_label", {
              plate: vehicleB.vehicleInfo.plate,
            })}
            placeholder={t("commons.insert")}
          />
        }
        secondField={
          <InputPhone
            name={`phoneNumber`}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
            touched={formikSignatureB.touched.phoneNumber}
            value={formikSignatureB.values.phoneNumber}
            error={formikSignatureB.errors.phoneNumber}
            placeholder={t("commons.insert")}
            label={`${t("data_entry.signature_b_step.phone_field_label", {
              plate: vehicleB.vehicleInfo.plate,
            })}*`}
          />
        }
      />
    </div>
  );

  const Bottom = (
    <div className="d-flex flex-column jusfify-content-center">
      <Separator classes="mt-5 my-4" />
      <div className="flex-lg-row flex-column d-flex mx-lg-auto">
        <Button
          flavor="primaryFlip"
          classes="px-lg-5 mx-lg-5 mb-lg-0 mx-0 px-2 mb-3 "
          text={t("data_entry.signature_b_step.send_module_single_signature")}
          classesText="text-uppercase label-l--500"
          onPress={showRetryModal ? undefined : sendDossier}
          disabled={showRetryModal}
        />
        <Button
          flavor="primary"
          iconLeft={RightArrowIcon}
          classes="px-lg-5 mx-lg-5 mt-lg-0 mx-0 px-2 mt-3"
          text={t("data_entry.signature_b_step.save_and_send_module_to_firm")}
          classesText="text-uppercase label-l--500"
          onPress={showRetryModal ? undefined : handleSubmit}
          disabled={showRetryModal}
        />
      </div>
    </div>
  );

  if (isLoadingCommunicationToken) {
    return null;
  }

  if (signatureChoiceVisibility) {
    return <SignatureStep onSubmit={createDossier} />;
  }

  return (
    <div>
      {showRetryModal && (<ModalSignature onRetry={checkSignStatus} signInProgressMessage={signInProgressMessage}/>)}
      {TopBody}
      <form>
        <main>
          <div>
            {Title}
            {Body}
          </div>
        </main>
        {Bottom}
      </form>
    </div>
  );
});
